import ProjectDeadlineExtensionsForm from '../../components/Form';

export default function ProjectDeadlineExtensionsEdit() {
  return <ProjectDeadlineExtensionsForm />;
}
